module.exports = __webpack_public_path__ + "assets/img/9_360_big.f4c8dd38.jpg";